import { useMutation } from '@tanstack/react-query';
import { settingsService } from '../services/settings.service';
import type { UpdatePasswordData } from '../types/settings.types';

export function useUpdatePassword() {
  return useMutation({
    mutationFn: (data: UpdatePasswordData) => settingsService.updatePassword(data),
  });
}
